function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M79.467,73.842l-31.801-31.8c7.605-10.331,6.767-24.973-2.576-34.316c-10.301-10.301-27.062-10.301-37.363,0 c-10.301,10.301-10.301,27.063,0,37.363c9.343,9.343,23.985,10.183,34.316,2.577l31.8,31.8c1.553,1.554,4.07,1.554,5.624,0 C81.02,77.913,81.02,75.395,79.467,73.842z M39.466,39.465c-7.2,7.2-18.915,7.2-26.116,0c-7.2-7.2-7.2-18.915,0-26.115 c7.201-7.201,18.916-7.201,26.116,0C46.666,20.55,46.666,32.265,39.466,39.465z M37.626,23.572c1.485,0,2.689,1.205,2.689,2.69 c0,1.485-1.205,2.69-2.689,2.69h-8.673v8.672c0,1.486-1.204,2.69-2.69,2.69s-2.69-1.206-2.69-2.69v-8.672h-8.673 c-1.485,0-2.689-1.205-2.689-2.69c0-1.485,1.205-2.69,2.689-2.69h8.673v-8.673c0-1.486,1.205-2.69,2.69-2.69s2.69,1.204,2.69,2.69 v8.673H37.626z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var SvgZoomIn = function SvgZoomIn(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "80.631px",
    height: "80.631px",
    viewBox: "0 0 80.631 80.631",
    style: {
      enableBackground: "new 0 0 80.631 80.631"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgZoomIn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/zoom-in.7e54b4fe.svg";
export { ForwardRef as ReactComponent };